{
  "name": "easytrack-admin",
  "version": "2.11.0-SNAPSHOT",
  "scripts": {
    "ng": "ng",
    "start": "ng serve -c local -o",
    "start:test": "ng serve -c test-env",
    "azure-test-start": "ng serve --configuration=azure-test -o",
    "azure-start": "ng serve --configuration=azure -o",
    "build": "ng build",
    "test": "ng test --coverage",
    "test:watch": "ng test --watch",
    "lint": "ng lint",
    "build-install:lib": "cd ../bs-components && npm run build-pack:local && cd - && npm run install:lib",
    "install:lib": "npm install ../bs-components/dist/bs-components/bs-components-1.0.1-dev.tgz",
    "e2e:open": "playwright test --ui",
    "e2e:run": "playwright test"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^21.2.8",
    "@angular/cdk": "^21.2.6",
    "@angular/common": "^21.2.8",
    "@angular/compiler": "^21.2.8",
    "@angular/core": "^21.2.8",
    "@angular/forms": "^21.2.8",
    "@angular/material": "^21.2.6",
    "@angular/platform-browser": "^21.2.8",
    "@angular/platform-browser-dynamic": "^21.2.8",
    "@angular/router": "^21.2.8",
    "@fortawesome/fontawesome-free": "^7.2.0",
    "@ngx-translate/core": "^17.0.0",
    "@ngx-translate/http-loader": "^17.0.0",
    "bootstrap": "^5.3.8",
    "bs-components": "1.7.0",
    "date-fns": "^4.1.0",
    "event-source-polyfill": "^1.0.31",
    "html2canvas": "^1.4.1",
    "jspdf": "^4.2.1",
    "jspdf-autotable": "^5.0.7",
    "jszip": "^3.10.1",
    "keycloak-angular": "^21.0.0",
    "keycloak-js": "^26.2.3",
    "lodash": "^4.18.1",
    "ngx-extended-pdf-viewer": "^26.0.1",
    "ngx-spinner": "^21.1.0",
    "rxjs": "^7.8.2",
    "tslib": "^2.8.1",
    "xlsx": "^0.18.5",
    "zone.js": "~0.16.1"
  },
  "devDependencies": {
    "@angular-builders/jest": "^21.0.3",
    "@angular-eslint/builder": "^21.3.1",
    "@angular-eslint/eslint-plugin": "^21.3.1",
    "@angular-eslint/eslint-plugin-template": "^21.3.1",
    "@angular-eslint/schematics": "^21.3.1",
    "@angular-eslint/template-parser": "^21.3.1",
    "@angular/build": "^21.2.7",
    "@angular/cli": "^21.2.7",
    "@angular/compiler-cli": "^21.2.8",
    "@bgotink/playwright-coverage": "^0.3.2",
    "@playwright/test": "^1.59.1",
    "@types/bootstrap": "^5.2.10",
    "@types/jest": "^30.0.0",
    "@types/lodash": "^4.17.24",
    "@types/node": "^25.5.2",
    "@typescript-eslint/eslint-plugin": "^8.58.1",
    "@typescript-eslint/parser": "^8.58.1",
    "dotenv": "^17.4.1",
    "eslint": "^10.2.0",
    "jest": "^30.3.0",
    "jest-canvas-mock": "^2.5.2",
    "jest-environment-jsdom": "^30.3.0",
    "jest-preset-angular": "^16.1.2",
    "jsdom": "^29.0.2",
    "typescript": "~5.9.3",
    "webpack": "^5.106.0"
  },
  "browserslist": [
    "> 0.5%",
    "last 2 versions",
    "Firefox ESR",
    "not dead",
    "not IE 9-11"
  ],
  "jest": {
    "setupFiles": [
      "jest-canvas-mock"
    ]
  }
}
